<template>
  <div class="welcome-screen">
    <img src="../../../resources/images/create-application.svg" alt="Create application" />
    <h3 class="get-started-heading">Get Started</h3>
    <p class="get-started-description">Create an app to manage API keys and make authenticated API calls.</p>
    <VButton connotation="cta" appearance="filled" label="Create a new application" @click="$router.push('/developer-portal/applications/create')">
      <template #icon>
        <VIcon name="plus-line" />
      </template>
    </VButton>
  </div>
</template>

<script>
export default {
  name: "DeveloperPortal",
};
</script>

<style lang="scss" scoped>
.welcome-screen {
  height: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  background-color: var(--white);
  padding: 16px;
}
.get-started-heading {
  font-weight: 700;
  font-size: 18px;
  color: var(--gray-04);
}
.get-started-description {
  font-weight: 400;
  font-size: 18px;
  color: var(--gray-04);
}
</style>
